<template>
    <div class="grid">
        <div class="box" v-for="categoria in categorias" :key="categoria.categoria" >
            <div class="header">
                <h1>{{ categoria.categoria }}</h1>
            </div>
            <div class="card" >
                <div class="card-container" v-for="sistema in categoria.sistemas" :key="sistema" >
                    <a :href="sistema.link" target="_blank">
                    <div class="title">{{sistema.nome}}</div>
                    <div class="logo"><box-icon :name='sistema.icon' type='solid' color='var(--surface-500)' size='36px' ></box-icon></div>
                    <div class="description">{{ sistema.descricao }}</div>
                    </a>
                    
                </div>
                
            </div>      
        </div>

    </div>
</template>

<script>
import data from '../data/data_categoria';
export default {
    name: 'GridCategorias', 
    data() {
        return {
            categorias: data,
            
        }
    },
}
</script>

<style>

</style>
